import { render, staticRenderFns } from "./ContractorRoleAdd.vue?vue&type=template&id=547dfd4a&scoped=true&"
import script from "./ContractorRoleAdd.vue?vue&type=script&lang=js&"
export * from "./ContractorRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547dfd4a",
  null
  
)

export default component.exports